import React, { Fragment, useState } from 'react'
import { Spinner } from 'react-bootstrap';
import Form from '../../../Common/Form';
import InputButton from '../../../Common/InputButton';
import Modalb from '../../../Common/Modal/Modalb';
import SelectCategory from '../../../Common/SelectCategory';
import Category from './Category';


const Categories = ({ add, categories, getData, modal, remove, setModal, loading }) => {
    const [val, setVal] = useState();
    const befor = (e) => {
        setVal(e.target.files[0])
    }
    return (
        <div className='Users'>
            <div className='main d-flex mb-3'>
                <div className='filter-card'>
                    <button type="button" onClick={() => setModal(true)} >
                        <div className='d-flex align-items-center'>
                            <span>افزودن دسته بندی</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={18} height={18}>
                                <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
            <table className='w-100 contact mb-3 user-card'>
                <thead className='w-100'>
                    <tr className='d-flex align-items-center justify-content-around '>
                        <th>شماره دسته بندی</th>
                        <th>نام دسته بندی</th>
                        <th>زیر دسته</th>
                        <th>حذف/مشاهده</th>
                    </tr>
                </thead>
            </table>
            <div className="users">
                {loading ? <div className='d-flex align-items-center justify-content-center'> <Spinner animation='border' /> </div> :
                    categories?.data?.map((category, i) => {
                        return <Category {...category} category={category} key={i} remove={remove} />
                    })
                }
            </div>
            <div className='pagination'>
                <div className='d-flex'>
                    {categories?.prev_page_url ?
                        <div onClick={() => { getData(categories?.prev_page_url) }} className="circle">
                            <span>&laquo;</span>
                        </div>
                        : null}
                    {categories?.links?.map((link, i) => {
                        let index = categories.links.findIndex(x => x.active === true);
                        if (categories.links.length > 5) {
                            if (i != 0 && i != (categories.links.length - 1) && i < (index + 5) && i >= (index - 1)) {
                                if (link.url && link.label != "Next &raquo;" && link.label != "&laquo; Previous") {
                                    return (
                                        <div onClick={() => { getData(link.url) }} key={i} className={link.active ? "circle active " : "circle"}>
                                            <span>{link.label}</span>
                                        </div>
                                    )
                                }
                            }
                        } else {
                            if (link.url && link.label != "Next &raquo;" && link.label != "&laquo; Previous") {
                                return (
                                    <div onClick={() => { getData(link.url) }} key={i} className={link.active ? "circle active " : "circle"}>
                                        <span>{link.label}</span>
                                    </div>
                                )
                            }
                        }
                    })}
                    {categories?.next_page_url ?
                        <div onClick={() => { getData(categories?.next_page_url) }} className="circle">
                            <span>&raquo;</span>
                        </div>
                        : null}
                </div>
            </div>
            <Modalb
                size="lg"
                show={modal}
                onHide={() => setModal(false)}
                Title="افزودن دسته بندی">
                <Form submit={add}>
                    <div className="card-body p-3">
                        <div className="col-md-6 col-12">
                            <div className='inp-group'>
                                <label htmlFor="Name">نام دسته بندی</label>
                                <br />
                                <input name='name' type="text" id='name' style={{ width: "100%" }} />
                            </div>
                            <SelectCategory name='parent_id' />
                            <div className='inp-group'>
                                <label htmlFor="Name">عنوان صفحه</label>
                                <br />
                                <input name='seo[title]' type="text" id='name' style={{ width: "100%" }} />
                            </div>
                            <div className='inp-group'>
                                <label htmlFor="Name">کلمات کلیدی(سئو)</label>
                                <br />
                                <input name='seo[keywords]' type="text" id='name' style={{ width: "100%" }} />
                            </div>
                            <div className='inp-group'>
                                <label htmlFor="Name">توضیحات(سئو)</label>
                                <br />
                                <input name='seo[description]' type="text" id='name' style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className='enter-image'>
                                <input name='image' type="file" accept="image/*" onChange={befor} />
                                {val ?
                                    <Fragment>
                                        <img id='image' src={URL.createObjectURL(val)} alt="عکس محصول" />
                                        <div className="add-logo bob">
                                            <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path d="M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z" />
                                            </svg>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="add-logo">
                                        <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path d="M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z" />
                                        </svg>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <InputButton />
                    </div>
                </Form>
            </Modalb>
        </div>
    )
}

export default Categories